;(function($) {


    function getDomain() {
        var parts = location.hostname.split('.')
        return parts.slice(-2).join('.')
    }

    function setCookie(cname, cvalue, exdays) {
        var d = new Date()
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
        var expires = 'expires=' + d.toUTCString()
        document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/; domain=' + getDomain()
    }

    function getCookie(cname) {
        var name = cname + '='
        var ca = document.cookie.split(';')
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i]
            while (c.charAt(0) === ' ') {
                c = c.substring(1)
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length)
            }
        }
        return ''
    }

    var accepted = getCookie('accept')

    var $cookies = $('.cookie-info')

    if (accepted !== 'true') {
        $cookies.addClass('is-active')
        $cookies.find('button').click(function () {
            $cookies.slideUp(600)
            setTimeout(function () {
                $cookies.removeClass('is-active')
            }, 600)
            setCookie('accept', 'true', 30)
        })
    } else {
        $cookies.hide()
    }


}(jQuery));
